<template>
  <div class="o-card u-padding-xsmall">
    <Tabs with-route :tabs="tabs">
      <template #cycles> <BatteryCycles :battery="battery" /> </template>
      <template #changedLogs> <ChangedLogs :battery="battery" /> </template>
      <template #permissions>
        <BatterPermissions :battery="battery"
      /></template>
      <template #features>
        <BatteryFeatures
          :features="features"
          :result="result"
          :battery="battery"
        />
      </template>
    </Tabs>
  </div>
</template>

<script>
import Tabs from "@/components/Base/Tabs.vue";
import BatterPermissions from "./BatterPermissions.vue";
import BatteryCycles from "./BatteryCycles.vue";
import ChangedLogs from "../ChangedLogs.vue";
import BatteryFeatures from "./BatteryFeatures.vue";
export default {
  components: {
    Tabs,
    BatteryCycles,
    BatterPermissions,
    ChangedLogs,
    BatteryFeatures,
  },
  props: ["battery", "features", "result"],
  data() {
    return {
      tabs: [
        {
          label: this.$t("batteryDetail.tabs.features"),
          tab: "features",
        },
        {
          label: this.$t("batteryDetail.tabs.cycles"),
          tab: "cycles",
        },
        {
          label: this.$t("batteryDetail.tabs.permissions"),
          tab: "permissions",
        },
        {
          label: this.$t("batteryDetail.batteryLogs"),
          tab: "changedLogs",
        },
      ],
    };
  },
};
</script>

<style></style>
